import { render, staticRenderFns } from "./CaptureInventoryTags.vue?vue&type=template&id=e1f71a2a&scoped=true"
import script from "./CaptureInventoryTags.vue?vue&type=script&lang=js"
export * from "./CaptureInventoryTags.vue?vue&type=script&lang=js"
import "./CaptureInventoryTags.vue?vue&type=style&index=0&id=e1f71a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f71a2a",
  null
  
)

export default component.exports